
export function formatCPF(value) {
    const cleanValue = value.replace(/\D/g, '').substring(0, 11);

    let finalValue = cleanValue.substring(0, 3);
    const part2 = cleanValue.substring(3, 6);
    if (part2) {
        finalValue += `.${part2}`;
        const part3 = cleanValue.substring(6, 9);
        if (part3) {
            finalValue += `.${part3}`;
            const part4 = cleanValue.substring(9, 11);
            if (part4) {
                finalValue += `-${part4}`;
            }
        }
    }
    return finalValue;
}

export function validateCpf(text) {
    let first = text.substring(0, 3);
    let second = text.substring(4, 7);
    let third = text.substring(8, 11);
    let fourth = text.substring(12, 14);
  
    var i;
    var number;
    var result = true;
  
    number = first + second + third + fourth;
  
    let s = number;
    let c = s.substr(0, 9);
    var dv = s.substr(9, 2);
    var d1 = 0;
  
    for (i = 0; i < 9; i++) {
      d1 += c.charAt(i) * (10 - i);
    }
  
    if (d1 === 0) {
      result = false;
    }
  
    d1 = 11 - (d1 % 11);
    if (d1 > 9) d1 = 0;
  
    if (dv.charAt(0) !== d1) {
      result = false;
    }
  
    d1 *= 2;
    for (i = 0; i < 9; i++) {
      d1 += c.charAt(i) * (11 - i);
    }
  
    d1 = 11 - (d1 % 11);
    if (d1 > 9) d1 = 0;
  
    if (dv.charAt(1) !== d1) {
      result = false;
    }
  
    if (number.length !== 11) {
      result = false;
    }
  
    return result;
  }

export const formatReal = (value) => {
  return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
  }).format(value);
}


// WEBPACK FOOTER //
// ./src/views/Util/util.js